import request from '@/plugin/axios'

// 登录接口
export function login(data) {
  return request({
    url: '/user/oprSysUser/login',
    // url: '/base/sys/login',
    method: 'POST',
    data
  })
}

export function userInfo(data) {
  return request({
    url: '/user/oprSysUser/info',
    method: 'GET',
    params: data
  })
}
// 获取手机验证码
export function sendCode(data) {
  return request({
    url: '/user/oprSysUser/sendCode',
    method: 'POST',
    data
  })
}

// 校验系统是否存在手机号
export function checkSysUserMobile(data) {
  return request({
    url: '/user/oprSysUser/checkSysUserMobile',
    method: 'GET',
    params: data
  })
}

// 登出接口
export function Logout(data) {
  return request({
    url: '/user/oprSysUser/logout',
    // url: '/base/sys/logout',
    method: 'POST',
    data
  })
}
// 忘记密码 验证手机号验证码
export function checkMobileSmsCode(data) {
  return request({
    url: '/base/sys/checkMobileSmsCode',
    method: 'POST',
    data
  })
}

// 忘记密码 确认密码

export function confirmPassword(data) {
  return request({
    url: '/base/sys/confirmPassword',
    method: 'POST',
    data
  })
}
// token续期

export function refreshToken(data) {
  return request({
    url: '/user/oprSysUser/refreshToken',
    method: 'POST',
    data
  })
}
